import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingService } from '@zaoblako/web/core/services/routing.service';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';

@Component({
  standalone: true,
  selector: 'crm-go-back-button',
  template: `
    <crm-button
      [label]="label"
      [styleClass]="buttonClass"
      (onClick)="btnClick()"></crm-button>
  `,
  imports: [CommonModule, ButtonComponent]
})
export class GoBackButtonComponent {
  @Input() public label = 'Отмена';
  @Input() public buttonClass = 'p-button-secondary p-button-text';

  @Input() public route = '/';

  public constructor(
    private readonly router: Router,
    public readonly routingService: RoutingService,
    private readonly authService: AuthService
  ) {}

  public btnClick() {
    if (this.routingService.previousUrl === '/') {
      this.router.navigate([this.route]).catch(console.error);
    } else {
      this.routingService.goToPreviousUrl(this.authService.currentProfile?.sessionMode);
    }
  }
}
